import { render, staticRenderFns } from "./management.cattle.io.user.vue?vue&type=template&id=b989d638&"
import script from "./management.cattle.io.user.vue?vue&type=script&lang=js&"
export * from "./management.cattle.io.user.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports